import { render, staticRenderFns } from "./LowBalanceDialog.vue?vue&type=template&id=1b75e5bf"
import script from "./LowBalanceDialog.vue?vue&type=script&lang=js"
export * from "./LowBalanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports